import { Dispatch } from 'react';
import { InsuranceJourneyPersonalDetailsType } from '../../../components/common/CommonTypes';
import ActionTypes from '../ActionTypes';

export const PersonalDetailsPageEventHandlers = (
  personalDetails: InsuranceJourneyPersonalDetailsType,
  dispatch: Dispatch<ActionTypes>
) => {
  return {
    onChangeTitle: (value: string) => {
      dispatch({
        type: 'set-personal-details',
        personalDetails: { ...personalDetails, title: value }
      });
    },
    onChangeGenderSelection: (value: string) => {
      dispatch({
        type: 'set-personal-details',
        personalDetails: { ...personalDetails, gender: value }
      });
    },
    onChangeFirstName: (
      e:
        | React.FormEvent<HTMLInputElement>
        | React.ChangeEvent<HTMLSelectElement>
    ) => {
      dispatch({
        type: 'set-personal-details',
        personalDetails: {
          ...personalDetails,
          firstName: e.currentTarget.value
        }
      });
    },
    onChangeLastName: (
      e:
        | React.FormEvent<HTMLInputElement>
        | React.ChangeEvent<HTMLSelectElement>
    ) => {
      dispatch({
        type: 'set-personal-details',
        personalDetails: { ...personalDetails, lastName: e.currentTarget.value }
      });
    },
    onChangeDateOfBirth: (value: Date | undefined) => {
      dispatch({
        type: 'set-personal-details',
        personalDetails: { ...personalDetails, dateOfBirth: value }
      });
    },
    onChangeEmailAddress: (
      e:
        | React.FormEvent<HTMLInputElement>
        | React.ChangeEvent<HTMLSelectElement>
    ) => {
      dispatch({
        type: 'set-personal-details',
        personalDetails: { ...personalDetails, email: e.currentTarget.value }
      });
    },
    onChangeHomePhone: (
      e:
        | React.FormEvent<HTMLInputElement>
        | React.ChangeEvent<HTMLSelectElement>
    ) => {
      const numericValue = e.currentTarget.value.replace(/[^0-9]/g, '');
      dispatch({
        type: 'set-personal-details',
        personalDetails: { ...personalDetails, homePhone: numericValue }
      });
    },
    onChangeMobilePhone: (
      e:
        | React.FormEvent<HTMLInputElement>
        | React.ChangeEvent<HTMLSelectElement>
    ) => {
      const numericValue = e.currentTarget.value.replace(/[^0-9]/g, '');
      dispatch({
        type: 'set-personal-details',
        personalDetails: { ...personalDetails, mobilePhone: numericValue }
      });
    },
    onChangeMaritalStatus: (value: string) => {
      dispatch({
        type: 'set-personal-details',
        personalDetails: { ...personalDetails, maritalStatus: value }
      });
    },
    onChangeExpiryMonth: (value: string) => {
      dispatch({
        type: 'set-personal-details',
        personalDetails: { ...personalDetails, expiryMonth: value }
      });
    },
    onChangeResidentSinceBirth: (value: boolean): void => {
      dispatch({
        type: 'set-personal-details',
        personalDetails: { ...personalDetails, residentSinceBirth: value }
      });
    },
    onChangeResidentSinceDate: (value: Date | undefined): void => {
      dispatch({
        type: 'set-personal-details',
        personalDetails: { ...personalDetails, residentSinceDate: value }
      });
    },
    onChangeEmploymentStatus: (value: string) => {
      dispatch({
        type: 'set-personal-details',
        personalDetails: { ...personalDetails, employmentStatus: value }
      });
    },
    onChangeOccupation: (value: string, key?: string) => {
      dispatch({
        type: 'set-personal-details',
        personalDetails: {
          ...personalDetails,
          occupation: value,
          occupationKey: key
        }
      });
    },
    onChangeIndustry: (value: string, key?: string) => {
      dispatch({
        type: 'set-personal-details',
        personalDetails: {
          ...personalDetails,
          industry: value,
          industryKey: key
        }
      });
    },
    onChangeOwnHome: (value: boolean) => {
      dispatch({
        type: 'set-personal-details',
        personalDetails: { ...personalDetails, ownHome: value }
      });
    }
  };
};
